import { useLanguage } from "../context/LanguageContext";
import { useT } from "../i18n";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const Classes = () => {
  const { lang } = useLanguage();
  const t = useT(lang);

  return (
    <div className="py-24 md:py-32">
      <div className="container-wc">
        <div className="max-w-3xl mb-20 fade-up">
          <div className="flex items-center gap-3 mb-4">
            <span className="divider-gold" />
            <span className="eyebrow">{t.nav.classes}</span>
          </div>
          <h1 className="h-display text-5xl md:text-6xl mb-6">{t.classes.title}</h1>
          <p className="text-dim text-lg leading-relaxed">{t.classes.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {t.classes.list.map((c, i) => (
            <div
              key={c.t}
              data-testid={`classes-item-${i}`}
              className={`card relative overflow-hidden ${i % 3 === 0 ? "md:col-span-2" : ""}`}
            >
              <div className="flex items-start justify-between mb-6">
                <span className="text-gold tracking-[0.3em] text-xs">0{i + 1}</span>
                <span className="font-cn text-primary opacity-30 text-4xl leading-none">武</span>
              </div>
              <h3 className="font-serif text-3xl md:text-4xl mb-4">{c.t}</h3>
              <p className="text-dim leading-relaxed text-base max-w-xl">{c.d}</p>
              <Link to="/contact" data-testid={`classes-cta-${i}`} className="mt-6 inline-flex items-center gap-2 text-gold text-sm uppercase tracking-widest hover:gap-4 transition-all duration-300">
                {lang === "el" ? "Κλείστε μάθημα" : "Book lesson"} <ArrowRight size={14} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Classes;
